<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/fellow/products/*', { eager: true });

console.log(imagesGlob);

useHead({});

const products = [
	{ 
		title: 'Carter Carry Water Bottle',
		src: imagesGlob['../../images/brands/fellow/products/carter-carry-water-bottle.webp'].default,
	},
	{ 
		title: 'Carter Cold Tumbler',
		src: imagesGlob['../../images/brands/fellow/products/carter-cold-tumbler.webp'].default,
	},
	{ 
		title: 'Stagg EKG Electric Kettle',
		src: imagesGlob['../../images/brands/fellow/products/stagg-ekg-electric-kettle.webp'].default,
	},
	{ 
		title: 'Carter Move Mug',
		src: imagesGlob['../../images/brands/fellow/products/carter-move-mug.webp'].default,
	},
	{ 
		title: 'Clara French Press',
		src: imagesGlob['../../images/brands/fellow/products/clara-french-press.webp'].default,
	},
	{ 
		title: 'Opus Conical Burr Grinder',
		src: imagesGlob['../../images/brands/fellow/products/opus-conical-burr-grinder.webp'].default,
	},
	{ 
		title: 'Carter Slide Mug',
		src: imagesGlob['../../images/brands/fellow/products/carter-slide-mug.webp'].default,
	},
	{ 
		title: 'Corvo EKG Electric Kettle',
		src: imagesGlob['../../images/brands/fellow/products/corvo-ekg-electric-kettle.webp'].default,
	},
	{ 
		title: 'Ruby Wine Tumbler',
		src: imagesGlob['../../images/brands/fellow/products/ruby-wine-tumbler.webp'].default,
	}
]
</script>

<template lang="pug">
.page.page--brand.fellow
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/fellow/logo.png')
				h1 Custom Fellow
			.image
				img(src='@static/images/brands/fellow/hero.webp' alt="Black Fellow Ode Brew Grinder Gen 2 on a modern kitchen counter, with other coffee tools subtly in view.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Brew Ridiculously Good Coffee
				p Custom Fellow by Swagger isn’t just about drinks, it’s about leveling up every sip. From precision kettles and grinders to insulated mugs, travel tumblers, and sleek pour-over brewers, their gear is designed to enhance your favorite beverages with effortless style and expert performance. Whether you’re powering through your day or taking a moment to unwind, Fellow delivers tools that make every sip count.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Fellow ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="fellow")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/fellow/banner.png' alt="Black Fellow coffee displayed on a white counter as hot water is poured from a kettle into a coffee filter.")
			.section__content
				.copy
					h2 DESIGN THAT DELIVERS
					p Behind every Fellow product is innovative design crafted to perfect your brew. Think precision pour spouts, intuitive controls, and sleek silhouettes available in bold colors that pop. Built with premium materials and a keen eye for detail, Fellow’s gear looks as good as it performs, bringing both style and science to your daily ritual.
		
		section.section.section--foot
			.bg
			.section__content
		
</template>

<style></style>